// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e22461ca","239":"7f905b37","453":"c19a74f2","455":"f3578bce"}[chunkId] + ".chunk.js";
};